/**
 * Renders a single news item link
 */
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ThreeDots } from "react-loader-spinner";
import ImageContainer from "./../core/ImageContainer";
import { Link } from "react-router-dom";

const SingleNews = ({ title, img, author, id, url_override, external }) => {
  return (
    <Link
      className="w-full flex flex-row justify-start xl:items-start my-2 group"
      to={url_override ? url_override : `/news/${id}`}
      target={url_override ? (external ? "_blank" : "_self") : undefined}
    >
      <div className="xs:h-[80px] xs:w-[110px] xs:min-h-[80px] xs:max-h-[80px] xs:min-w-[110px] xs:max-w-[110px] min-w-[120px] h-[80px]">
        <ImageContainer src={img ? `https://buiha.org.uk/assets/img/resource/${img}` : "/placeholder2.jpg"} alt={title} />
      </div>
      <div className="flex flex-col justify-start items-start ml-2">
        <h1 className="text-sm text2l pb-1 leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
        {title.length > 50 ? `${title.slice(0, 50)}...` : title}
        </h1>
        <p className="text-xs text-darken font-light leading-tight">
          By {author}
        </p>
      </div>
    </Link>
  );
};

export default SingleNews;
